import React, { Component, PropTypes } from "react";
import { connect } from "react-redux";
import { menuNamesEnum } from "../state/initialState";
import ContentAppointment from "../components/pages/appointment/content";
import ContentWaitlist from "../components/pages/waitlist";
import ContentAppointmentAdvanced from "../components/pages/appointment-advanced/content";
import ContentAppointmentCheckout from "../components/pages/appointment-checkout/content";
import ContentCustomerNotes from "../components/pages/customer-notes/content";
import ContentCustomerProfile from "../components/pages/customer-profile/content";
import ContentBookingOnlyCustomerProfile from "../components/pages/booking-only-customer-profile/content";
import ContentCustomerRecentAppointment from "../components/pages/customer-recent-appointment/content";
import TopMenu from "../components/shared/topMenu";
import GlobalError from "../components/shared/globalError";
import GlobalSuccess from "../components/shared/globalSuccess";

import { updateGlobalErrorMessage } from "../actions/globalError";

@connect(mapStateToProps)
export default class App extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    const { currentMenu, appIsVisible, previousMenu, form } = this.props;

    let errorMessage = <GlobalError />;
    let successMessage = <GlobalSuccess />;
    let modalClass = "";
    let modalContent = "";

    if ("WAITLIST" === form) {
      modalContent = <ContentWaitlist />;
    } else {
      let currentMenuOptionContent = "";
      let topMenu = <TopMenu />;
      modalClass = "bookingdetails-model";

      switch (currentMenu) {
        case menuNamesEnum.FIRST_STEP_APPOINTMENT:
          currentMenuOptionContent = <ContentAppointment />;
          break;
        case menuNamesEnum.FIRST_STEP_WAITLIST:
          currentMenuOptionContent = <ContentWaitlist />;
          break;
        case menuNamesEnum.SECOND_STEP_ADVANCED:
          currentMenuOptionContent = <ContentAppointmentAdvanced />;
          break;
        case menuNamesEnum.THIRD_STEP_CHECKOUT:
          currentMenuOptionContent = <ContentAppointmentCheckout />;
          break;
        case menuNamesEnum.INTERMEDIATE_STEP_CUSTOMER_PROFILE_CREATE:
        case menuNamesEnum.INTERMEDIATE_STEP_CUSTOMER_PROFILE_EDIT:
          currentMenuOptionContent = (
            <ContentCustomerProfile previousMenu={previousMenu} />
          );
          break;
        case menuNamesEnum.INTERMEDIATE_STEP_CUSTOMER_NOTES:
          currentMenuOptionContent = <ContentCustomerNotes />;
          break;
        case menuNamesEnum.INTERMEDIATE_STEP_BOOKING_ONLY_CUSTOMER_PROFILE:
          currentMenuOptionContent = <ContentBookingOnlyCustomerProfile />;
          break;
        case menuNamesEnum.INTERMEDIATE_STEP_CUSTOMER_RECENT_APPOINTMENTS:
          currentMenuOptionContent = <ContentCustomerRecentAppointment />;
          break;
        default:
          currentMenuOptionContent = "";
      }

      modalContent = (
        <div>
          {" "}
          {topMenu} {currentMenuOptionContent}{" "}
        </div>
      );
    }

    return appIsVisible ? (
      <div className={modalClass}>
        {errorMessage}
        {successMessage}
        {modalContent}
      </div>
    ) : (
      <span />
    );
  }
}

function mapStateToProps(state) {
  return {
    currentMenu: state.menuReducer.currentMenu,
    previousMenu: state.menuReducer.previousMenu,
    appIsVisible: state.appStatusReducer.appIsVisible,
    form: state.appStatusReducer.form
  };
}
